<!-- Modal Container -->
<template>
  <transition name="modal-fade" class="modal-fade">
    <div class="modal-backdrop">
      <form @submit.prevent="addOrUpdateOrDeleteKeyword" action="#"  method="post">
      <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">           
            {{actionToBePerformed}}
            <div class="closeButton">
              <!-- <button type="button" class="btn" @click="close">Close</button> -->
            </div>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">            
              <div class="row">
                <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name">Id</label>
                  <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.id.required }" v-model="gRowObj.id" class="form-control" id="idforkeyword" placeholder="Id"  />
                  <span v-if="submitted && !$v.gRowObj.id.required" class="text-red pull-right">Please enter id.</span>
                </div>
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name">Keyword</label>
                  <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.keyword.required }" v-model="gRowObj.keyword" class="form-control" id="keyword" placeholder="Keyword"  />
                  <span v-if="submitted && !$v.gRowObj.keyword.required" class="text-red pull-right">Please enter keyword.</span>
                </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name">Conversation</label>
                  <!-- <input type="text" v-model="gRowObj.conversation" class="form-control" id="conversation" placeholder="Conversation"  /> -->
                  <nv-select v-model="gRowObj.conversation" class="form-control">
                    <option value="">--Choose a Conversation--</option>
                    <option v-for="(conv, index) in conversationApps" :selected="conv.name === gRowObj.conversation" :key="index" :value="conv.name">{{conv.name}}</option>
                  </nv-select>
                  <!-- <span v-if="submitted && !$v.gRowObj.conversation.required" class="text-red pull-right">Please choose conversation.</span> -->
                </div>
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="type">Type</label>                  
                  <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.type.required }" id="type" v-model="gRowObj.type">
                      <option value="">--Choose an App Type--</option>
                      <option v-for="(data, index) in appTypes" :key="index" :value="data.value">{{data.name}}</option>                      
                  </nv-select>
                  <span v-if="submitted && !$v.gRowObj.type.required" class="text-red pull-right">Please choose an app type.</span>
                </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="product">Product</label>
                  <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.product.required }" id="product" name="product" v-model="gRowObj.product">
                      <option value="">--Choose a Product--</option>
                      <option v-for="(data, index) in products" :key="index" :value="data.value">{{data.name}}</option>                     
                  </nv-select>
                  <span v-if="submitted && !$v.gRowObj.product.required" class="text-red pull-right">Please choose product.</span>
                </div>
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name">App Package</label>
                  <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.appPackage.required }" id="apppackage" name="apppackage" v-model="gRowObj.appPackage">
                      <option value="">--Choose an App Package--</option>
                      <option v-for="(data, index) in appPackages" :key="index" :value="data.value">{{data.name}}</option>
                  </nv-select>
                  <span v-if="submitted && !$v.gRowObj.appPackage.required" class="text-red pull-right">Please choose an app package.</span>
                </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name">Channel</label>                  
                  <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.channel.required }" id="channel" name="channel" v-model="gRowObj.channel">
                      <option value="">--Choose a Channel--</option>
                      <option v-for="(data, index) in channels" :key="index" :value="data.value">{{data.name}}</option>
                  </nv-select>
                  <div v-if="submitted && !$v.gRowObj.channel.required" class="text-red pull-right">Please choose channel.</div>                  
                </div>
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name">Language</label>                  
                  <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.language.required }" id="language" name="language" v-model="gRowObj.language">
                      <option value="">--Choose a Language--</option>
                      <option v-for="(data, index) in languages" :key="index" :value="data.value">{{data.name}}</option>                   
                  </nv-select>
                  <span v-if="submitted && !$v.gRowObj.language.required" class="text-red pull-right">Please choose language.</span>
                </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12 col-lg-12 col-xs-12">  
                  <div class="col-md-12 col-lg-12 col-xs-12">
                    <label for="facilities">Facilities</label>              
                    <input type="text" placeholder="Please enter comma-separated values" class="form-control" name="facilities" id="facilities"  v-model="gRowObj.facilities">                  
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <input type="checkbox" name="shouldaccepttnc" id="shouldaccepttnc" :checked="gRowObj.shouldaccepttnc"  v-bind:value="gRowObj.shouldaccepttnc" v-model="gRowObj.shouldaccepttnc">
                  <label for="shouldaccepttnc" class="margin-left-5px">Should Accept Terms & Conditions</label>
                </div>
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  
                </div>
                </div>
              </div>  
          </slot>
        </section>
        <footer class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-primary" @click="close">Cancel</button>
              <input type="submit" class="btn btn-primary" value="Submit">
          </slot>
        </footer>
      </div>
      </form>
    </div>
  </transition>
  <!-- Modal Container end -->
</template>
<script>
  import { required } from 'vuelidate/lib/validators'
  import { appTypes, products, appPackages, channels, languages } from './../../../config/constants'
  export default {
    name: 'modal',
    props: ['gRowObj', 'actionToBePerformed', 'validationErrors', 'conversationApps'],
    validations: {
      gRowObj: {
        id: { required },
        keyword: { required },
        type: { required },
        product: { required },
        appPackage: { required },
        channel: { required },
        language: { required }
      }
    },
    data () {
      return {
        appTypes: appTypes,
        products: products,
        appPackages: appPackages,
        channels: channels,
        languages: languages,
        validationErrors: [],
        gRowObj: {
          id: null,
          keyword: '',
          conversation: '',
          type: '',
          product: '',
          appPackage: '',
          locationid: '',
          channel: '',
          language: '',
          facilities: '',
          campaign: '',
          messages: '',
          attachedfacilities: '',
          client: '',
          overrideuserlocation: '',
          createdAt: '',
          shouldaccepttnc: false
        },
        submitted: false,
        actionToBePerformed: 'Add Keyword'
      }
    },
    methods: {
      close () {
        console.log('closing the modal')
        this.submitted = false
        this.$emit('close')
      },
      addOrUpdateOrDeleteKeyword (e) {
        console.log('inside addOrUpdateOrDeleteKeyword function')
        console.log(this.actionToBePerformed)
        console.log(this.gRowObj)
        if (this.actionToBePerformed !== 'Delete Keyword') {
          this.submitted = true
          this.$v.$touch()
          if (this.$v.$invalid) {
            return
          }
        }
        if (this.actionToBePerformed === 'Add Keyword') {
          console.log('Add Keyword')
          this.submitted = false
          this.$emit('addKeyword', this.gRowObj)
        } else if (this.actionToBePerformed === 'Update Keyword') {
          this.submitted = false
          this.$emit('updateKeyword', this.gRowObj)
        } else if (this.actionToBePerformed === 'Delete Keyword') {
          this.submitted = false
          this.$emit('deleteKeyword', this.gRowObj)
        }
      }
    }
  }
</script>
<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);    
    height:550px;    
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: inline-block;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    font-size: 18px;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
    min-height: 400px;    
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #0D9488;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #0D9488;
    border: 1px solid #0D9488;
    border-radius: 2px;
  }
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
  .closeButton {
    position:absolute;
    left:92%;
    top:-1%;
    font-weight: bold;
  }
  .text-red {
    color: red
  }
  .margin-left-20px {
    margin-left: 20px
  }
  .margin-left-5px {
    margin-left: 5px
  }
</style>


// WEBPACK FOOTER //
// addKeyword.vue?5bcc7158